// src/Register.js
import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import './AuthForm.css';
import { useNavigate } from 'react-router-dom';

const barangays = [
  "Em's Barrio", "Sagpon", "San Roque", "Bagumbayan", "Bgy 15", "Bgy 16"
  // ...add all barangays here 
];

function Register() {
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: '',
    isResident: false
  });
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
      document.title = "Register";
    }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { error: signUpError } = await supabase.auth.signUp({
        email: form.email,
        password: form.password
      });
      if (signUpError) {
        setError(signUpError.message);
        setLoading(false);
        return;
      }
      // Redirect to OTP verification page, passing email as state
      navigate('/verify-otp', { state: { email: form.email } });
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div 
        className="auth-logo-absolute"
        onClick={() => navigate('/')}
        style={{ cursor: 'pointer' }}
        title="Go to Homepage"
      >
        <img src="/GabaySakunaLogo.svg" alt="Gabay Sakuna Logo" className="auth-logo" />
        <span className="auth-title-main">GabaySakuna</span>
      </div>
      <div className="auth-split-bg">
        <div className="auth-split-left">
          <form className="login-form" onSubmit={handleRegister}>
            <div className="auth-title">Register</div>
            <input
              className="auth-input"
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={form.fullName}
              onChange={handleChange}
              required
            />
            <input
              className="auth-input"
              type="email"
              name="email"
              placeholder="Email or Mobile Number"
              value={form.email}
              onChange={handleChange}
              required
            />
            <input
              className="auth-input"
              type="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              required
            />
            <input
              className="auth-input"
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
            <div style={{ textAlign: 'left', marginBottom: 20, marginTop: 20 }}>
              <label>
                <input
                  type="checkbox"
                  name="isResident"
                  checked={form.isResident}
                  onChange={e => setForm({ ...form, isResident: e.target.checked })}
                  style={{ marginRight: 8 }}
                />
                I am a resident of Legazpi City
              </label>
            </div>
            <button className="auth-btn" type="submit" disabled={loading}>
              {loading ? 'Registering...' : 'Register'}
            </button>
            {error && <div style={{ color: 'red', marginBottom: 10 }}>{error}</div>}
            {message && <div style={{ color: 'green', marginBottom: 10 }}>{message}</div>}
            <div className="auth-footer">
              Already have an account?
              <span
                className="auth-link"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate('/login')}
              > Sign in</span>
            </div>
            <div style={{ marginTop: 12, color: '#555', fontSize: 14, textAlign: 'center' }}>
              <b>Note:</b> After signing up, you will receive a 6-digit OTP code via email. Please check your inbox and enter the code on the next page to verify your account.
            </div>
          </form>
        </div>
        <div className="auth-split-right">
          <div className="auth-hero-content">
            <h2>Join GabaySakuna and help your community stay safe.</h2>
            <p>Create your account to access disaster response tools and community updates for Legazpi City.</p>
            <img src="/hero-image.svg" alt="GabaySakuna Hero" className="auth-hero-img" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;